export default "__VITE_ASSET__DJznjiHH__"